import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import logo from "../../../assets/images/logo.png";
import styles from "./AddVehical.module.css";
import clockImg from "../../../assets/images/clock.png";
import usb from "../../../assets/images/usbMonitor.png";
import { SubmitButton, TextComponent } from "../../../components";
import { TbDeviceRemote, TbScan } from "react-icons/tb";
import stepTwo from "../../../assets/images/stepTwo.png";
import { roles } from "../../../config/roles";
import Storage from "../../../utills/AsyncStorage";
import carImg from '../../../assets/images/car.png';
const AddVehical = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const role = Storage.getERole("@role");

  return (
    <div className={styles.mainCont}>
      <div className={styles.leftCont}>
        <img src={logo} className={styles.logoImg} />
      </div>
      <div className={styles.rightCont}>
        <div className={styles.subRightCont}>
         <img src={stepTwo} className={styles.stepImg}/>
         <img src={carImg} className={styles.carIcon}/>
         <TextComponent text={"Setup Vehicle Information"} className={styles.heading}/>
         <div className={styles.btnDiv} onClick={()=>navigate("/addVehicalInformation")}>
         <SubmitButton title={"Add a Vehical"} />
         </div>
        </div>
      </div>
    </div>
  );
};

export default AddVehical;
